import { useTranslation } from '@portals-platform/i18n';
import { Button, Spinner } from '@portals-platform/ui';
import { useFormContext } from '@portals-platform/ui-forms';
import { useNavigate } from '@tanstack/react-router';

interface CertificateFormActionsProps {
  onSaveDraft?: (() => void) | undefined;
  isEditMode?: boolean | undefined;
  onCancel?: (() => void) | undefined;
}

export function CertificateFormActions({
  onSaveDraft,
  isEditMode = false,
  onCancel,
}: CertificateFormActionsProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { formState } = useFormContext();
  const isSubmitting = formState.isSubmitting;

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button
        type="button"
        variant="ghost"
        disabled={isSubmitting}
        onClick={onCancel ?? (() => void navigate({ to: '/certificates' }))}
      >
        {t('actions.cancel')}
      </Button>
      {!isEditMode && (
        <Button type="button" variant="outline" disabled={isSubmitting} onClick={onSaveDraft}>
          {t('actions.saveDraft')}
        </Button>
      )}
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting && <Spinner className="size-4" aria-hidden="true" />}
        {t(isEditMode ? 'actions.saveChanges' : 'actions.reviewAndSubmit')}
      </Button>
    </div>
  );
}
